import { combineReducers } from "@reduxjs/toolkit";

import type { EventAction } from "entities/events/actionTypes";
import { EventType } from "entities/events/actionTypes";
import type { EventState } from "entities/events/types";
import { addUserChangeReset } from "entities/user/utils";

const initialState: EventState = { byId: {} };

const byId = (state = initialState.byId, action: EventAction): EventState["byId"] => {
  switch (action.type) {
    case EventType.FETCH_FOR_TOPIC_SUCCESS: {
      return action.payload.data.reduce(
        (accumulator, next) => ({ ...accumulator, [next.id]: { ...state[next.id], ...next } }),
        state,
      );
    }
    case EventType.FETCH_FOR_ID_SUCCESS: {
      return {
        ...state,
        [action.meta.id]: {
          ...state[action.meta.id],
          ...action.payload,
        },
      };
    }
    default:
      return state;
  }
};

export const eventsReducer = combineReducers({
  byId: addUserChangeReset(byId, initialState.byId),
});
